const router =[
    {
        path: '/orderDetail',
        meta: {
            title: 'orderDetail',
        },
        component: (resolve) => require(['../views/orderDetail/orderDetail'], resolve)
    },
  ];
  
  export default router;


// WEBPACK FOOTER //
// ./src/router/orderDetail.js